import {CANVAS_ORIENTATION} from '~/common/canvas/constants';
import fabric from '~/common/canvas/fabric';
import {DEFAULT_HEIGHT_DESKTOP} from '~/common/FabricInvitation/EventCreateDesign/constants';

function getScaledImageSize(device, orientation, customDimensionMap = null) {
  const ORIGINAL_IMAGE_SIZES = {
    portrait: [1000, 1360],
    landscape: [1360, 1000],
    square: [1360, 1360],
  };

  const dimensionMap = customDimensionMap ?? CANVAS_ORIENTATION;

  const [originalWidth, originalHeight] = ORIGINAL_IMAGE_SIZES[orientation];
  const [targetWidth, targetHeight] = dimensionMap[device][orientation];
  const scale = Math.min(targetWidth / originalWidth, targetHeight / originalHeight);

  const scaledWidth = originalWidth * scale;
  const scaledHeight = originalHeight * scale;

  return {
    width: scaledWidth,
    height: scaledHeight,
    scale,
  };
}

const CONTROL_VISIBILITY = {
  uYOImage: false,
  textbox: true,
};

export const useCanvas = (
  canvasEl,
  configJson,
  callback,
  isDesktop,
  orientation,
  defaultDesktopHeight = DEFAULT_HEIGHT_DESKTOP,
  readOnly = false,
  customDimensionMap = null
) => {
  const [width, height] = orientation.dimensions || CANVAS_ORIENTATION.desktop.portrait;

  const canvasInstance = new fabric.Canvas(canvasEl, {
    width,
    height,
    includeDefaultValues: false,
    preserveObjectStacking: true,
    selection: !evite.detects.isMobile,
    controlsAboveOverlay: true,
    allowTouchScrolling: true,
  });

  const setCurrentDimensions = (parentNode, canvasWrapperRef) => {
    const {width, height, scale} = getScaledImageSize(
      isDesktop ? 'desktop' : 'mobile',
      orientation.orientation,
      customDimensionMap
    );

    canvasInstance.setDimensions({width, height});
    canvasInstance.setZoom(scale);
  };

  const loadCanvas = (jsonConfig) => {
    const reviver = (json, obj) => {
      const isUYOImage = obj.type === 'uYOImage';
      const isTextbox = obj.type === 'textbox';

      const shouldBeVisible = CONTROL_VISIBILITY[obj.type];

      obj.setControlsVisibility({
        mtr: shouldBeVisible,
        remove: shouldBeVisible,
      });

      obj._originalObject =
        isUYOImage && obj._originalObject ? obj._originalObject : JSON.parse(JSON.stringify(obj));
      obj.selectable = isTextbox || isUYOImage;
      obj.evented = isTextbox || isUYOImage;

      if (isUYOImage && (!obj.src || obj.src === obj._originalObject.src)) {
        // UYO image either has no src or has the placeholder src
        obj.set({
          lockMovementX: true,
          lockMovementY: true,
          lockScalingX: true,
          lockScalingY: true,
          lockRotation: true,
          selectable: false, // makes the gray box unselectable
        });
      }
      return obj;
    };
    if (canvasInstance && callback && jsonConfig)
      canvasInstance.loadFromJSON(jsonConfig, () => callback(canvasInstance), reviver);
  };

  if (configJson) {
    loadCanvas(configJson);
  }

  return {
    canvasInstance,
    setCurrentDimensions,
  };
};
